import React from "react";
import StringInput from "../formElements/StringInput";
import {useParams} from "react-router-dom";
import GenericForm from "./GenericForm";

function ManufacturerForm(props) {
    const {id} = useParams();

    const formContent = (data, update) => (
        <StringInput name={'Meno'} label={'Meno'} value={data.Meno} onChange={update} />
    );

    return (
        <GenericForm
            label="Výrobca"
            labelNew="Pridať Výrobcu"
            baseUrl='/product/manufacturers/'
            id={id}
            formContent={formContent}
        />
    );
}

export default ManufacturerForm;